import { TwcProduct } from '../../../twc-products';

export const ICING_PRODUCT_DATA: TwcProduct = {
  id: 'icing',
  defaultProductId: 'fip-FL240-boeing', //'fip-FLxxx-boeing',
  productName: 'Weather-Icing-TWC',
  label: 'Icing',
  weatherType: 'ICING',
  description: 'TWC product (raster, forecast) - Icing Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 180,
  flightLevelProductIds: {
    FL010: 'fip-FL010-boeing',
    FL020: 'fip-FL020-boeing',
    FL030: 'fip-FL030-boeing',
    FL050: 'fip-FL050-boeing',
    FL060: 'fip-FL060-boeing',
    FL080: 'fip-FL080-boeing',
    FL100: 'fip-FL100-boeing',
    FL120: 'fip-FL120-boeing',
    FL140: 'fip-FL140-boeing',
    FL160: 'fip-FL160-boeing',
    FL180: 'fip-FL180-boeing',
    FL210: 'fip-FL210-boeing',
    FL240: 'fip-FL240-boeing'
  },
  zOrder: 90
};
